import { EnderecoDto } from "@/dtos/EnderedoDto";
import { api } from "./Api";
import { ApiResult } from "./ApiResult";
import { RequestEditarPerfil } from "@/dtos/Request/RequestEditarPerfil";
import { RequestAlterarSenha } from "@/dtos/Request/RequestAlterarSenha";
import { ConfirmarDadosCadastro } from "@/pages/PrimeiroAcesso";

export interface IRealizarLoginDTO {
    TokenAcesso: string,
    idUsuario: number,
    Nome: string,
    NomeSocial: string,
    CPF: string,
    DataNascimento: string,
    Sexo?: string,
    Telefone: string,
    Email: string,
    Assertiva: boolean,
    Endereco: EnderecoDto
}

export interface CadastrarDto {
    Nome: string,
    NomeSocial: string,
    CPF: string,
    Telefone: string,
    Email: string,
    Senha: string,
    Endereco: EnderecoDto
}

export interface BuscarCadastroPorCPFDto {
    Bloqueado: boolean,
    CPF: string,
    Nome: string,
    NomeSocial?: string,
    Telefone: string,
    Email: string
}

export interface BuscarDadosClientePrimeiroAcesso {
    CPF: string,
    Telefone: string,
    CPFMasked: string,
    TelefoneMasked: string
}

export interface PresenteadoDto {
    IdUsuario: number,
    Nome: string,
    CPF?: string,
    Telefone?: string,
    CEP?: string,
    Endereco?: EnderecoDto
    Email?: string,
}

export interface CadastrarPresenteado {
    idUsuario: number,
    Nome: string,
    CPF: string,
    Telefone: string,
    Endereco: EnderecoDto
    Email?: string,
}

export interface ObterCodigoVerificacaoClienteDto {
    EmailValido: boolean,
    Destino: string
}

class AcessoService {
    async signIn(login: string, senha: string): Promise<ApiResult<IRealizarLoginDTO>> {
        let { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>('Acesso/Login', { Login: login, Senha: senha, Origem: 'Web' });

        return result;
    }

    async buscarPresenteados() {
        let { data: result } = await api.get<ApiResult<PresenteadoDto[]>>('Acesso/BuscarPresenteados');

        return result;
    }

    async removerPresenteado(idUsuario: number) {
        let { data: result } = await api.post<ApiResult<any>>('Acesso/RemoverPresenteado/', { idUsuario });

        return result;
    }

    async adicionarPresenteado(presenteado: CadastrarPresenteado) {
        let { data: result } = await api.post<ApiResult<any>>('Acesso/CadastrarPresenteado/', presenteado);

        return result;
    }

    async buscarDadosClientePrimeiroAcesso(login: string) {
        let { data: result } = await api.post<ApiResult<BuscarDadosClientePrimeiroAcesso>>('Acesso/BuscarDadosClientePrimeiroAcesso', { Login: login });

        return result;
    }

    async cadastrarPrimeiroAcesso(dados: ConfirmarDadosCadastro): Promise<ApiResult<IRealizarLoginDTO>> {
        let { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>('Acesso/AcessoClienteSemSenha', dados);

        return result;
    }

    async cadastrar(cadastrarDto: CadastrarDto): Promise<ApiResult<IRealizarLoginDTO>> {
        let { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>('Acesso/Cadastrar', cadastrarDto);

        return result;
    }

    async buscarSaldoCredito() {
        let { data: result } = await api.get<ApiResult<number>>('Acesso/BuscarSaldoCredito');

        return result;
    }

    async buscarCadastroPorCPF(cpf: string) {
        let { data: result } = await api.get<ApiResult<BuscarCadastroPorCPFDto>>('Acesso/BuscarCadastroPorCPF/' + cpf);

        return result;
    }

    async editarCadastro(dados: RequestEditarPerfil) {
        const { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>("Acesso/Editar", dados);
        return result
    }

    async alterarSenha(dados: RequestAlterarSenha) {
        const { data: result } = await api.post<ApiResult<any>>("Acesso/AlterarSenha", dados);
        return result
    }

    async esqueciMinhaSenha(login: string) {
        const { data: result } = await api.post<ApiResult<string>>("Acesso/EsqueciMinhaSenha", { Email: login });
        return result
    }

    async redefinirSenha(NovaSenha: string, Token: string) {
        const { data: result } = await api.post<ApiResult<string>>("Acesso/RedefinirSenha", { NovaSenha, Token });
        return result
    }

    async obterCodigoVerificacaoCliente(CPF: string, RecaptchaToken: string) {
        const { data: result } = await api.post<ApiResult<ObterCodigoVerificacaoClienteDto>>("Acesso/ObterCodigoAutenticacaoCliente", { CPF, RecaptchaToken });
        return result
    }

    async autenticarPorCodigo(RecaptchaToken: string, CPF: string, Codigo: string, Email?: string): Promise<ApiResult<IRealizarLoginDTO>> {
        let { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>('Acesso/AutenticarPorCodigo', { RecaptchaToken, CPF, Codigo, Email });

        return result;
    }

    async autenticarPorToken(token: string): Promise<ApiResult<IRealizarLoginDTO>> {
        let { data: result } = await api.post<ApiResult<IRealizarLoginDTO>>('Acesso/Reautenticar', { Token: token });

        return result;
    }
}

//eslint-disable-next-line
export default new AcessoService();